import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { toast } from "sonner";
import { Plus, Trash, PlugsConnected } from "@phosphor-icons/react";

export default function WebhooksPage() {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState({ name: "", url: "", event: "study_plan_request" });

  async function load() { const r = await api.get("/webhooks"); setItems(r.data); }
  useEffect(() => { load(); }, []);

  async function create() {
    try { await api.post("/webhooks", form); toast.success("Webhook criado"); load(); setForm({ name: "", url: "", event: "study_plan_request" }); }
    catch (e) { toast.error("Erro"); }
  }
  async function remove(id) { await api.delete(`/webhooks/${id}`); load(); }

  const backend = process.env.REACT_APP_BACKEND_URL;

  return (
    <div className="p-4 sm:p-8 lg:p-10 max-w-5xl mx-auto space-y-6">
      <header className="fade-up">
        <div className="text-xs uppercase tracking-[0.2em] font-bold text-[#1E5FFF]">N8N Integration</div>
        <h1 className="font-heading text-3xl sm:text-4xl font-black tracking-tighter mt-2">Webhooks & Agentes IA</h1>
      </header>

      <div className="bg-[#E0E7FF]/30 border border-[#002FA7]/30 rounded-md p-6 fade-up">
        <div className="flex items-start gap-3">
          <PlugsConnected size={24} weight="duotone" color="#002FA7" />
          <div>
            <h3 className="font-heading font-bold">Endpoint público N8N → App</h3>
            <p className="text-sm text-zinc-600 mt-1">Configure no N8N um HTTP Request para nosso endpoint:</p>
            <code className="block mt-2 p-3 bg-white border border-zinc-200 rounded text-xs font-mono select-all">
              POST {backend}/api/n8n/incoming<br/>
              Header: X-Webhook-Secret: n8n_webhook_secret_2026<br/>
              Body: {`{ "event": "activity_created", "payload": {...} }`}
            </code>
            <p className="text-xs text-zinc-500 mt-2">Eventos suportados: activity_created, study_plan_generated, doubt_answered.</p>
          </div>
        </div>
      </div>

      <div className="bg-white border border-zinc-200 rounded-md p-6 fade-up">
        <h3 className="font-heading text-lg font-bold mb-4">Novo webhook (App → N8N)</h3>
        <div className="grid md:grid-cols-3 gap-3">
          <div><Label>Nome</Label><Input data-testid="wh-name" value={form.name} onChange={e => setForm({...form, name: e.target.value})}/></div>
          <div>
            <Label>Evento</Label>
            <Select value={form.event} onValueChange={v => setForm({...form, event: v})}>
              <SelectTrigger data-testid="wh-event"><SelectValue/></SelectTrigger>
              <SelectContent>
                <SelectItem value="study_plan_request">Solicitação de plano de estudos</SelectItem>
                <SelectItem value="doubt_request">Dúvida do aluno</SelectItem>
                <SelectItem value="activity_created">Atividade criada</SelectItem>
              </SelectContent>
            </Select>
          </div>
          <div><Label>URL do webhook N8N</Label><Input data-testid="wh-url" value={form.url} onChange={e => setForm({...form, url: e.target.value})}/></div>
        </div>
        <Button data-testid="wh-add" onClick={create} className="mt-4 bg-[#002FA7] brutal-shadow"><Plus size={14} className="mr-1"/>Adicionar</Button>
      </div>

      <div className="bg-white border border-zinc-200 rounded-md fade-up">
        <table className="w-full text-sm">
          <thead><tr className="text-left text-[10px] uppercase tracking-wider text-zinc-500 border-b border-zinc-200">
            <th className="py-3 px-6">Nome</th><th>Evento</th><th>URL</th><th className="pr-6 text-right">Ação</th>
          </tr></thead>
          <tbody>
            {items.length === 0 && <tr><td colSpan={4} className="text-center py-12 text-zinc-400">Nenhum webhook configurado.</td></tr>}
            {items.map(w => (
              <tr key={w.id} className="border-b border-zinc-100">
                <td className="py-3 px-6 font-medium">{w.name}</td>
                <td className="text-xs">{w.event}</td>
                <td className="text-xs text-zinc-500 truncate max-w-xs">{w.url}</td>
                <td className="pr-6 text-right"><Button variant="ghost" size="sm" onClick={() => remove(w.id)}><Trash size={14}/></Button></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
